import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { wrap } from "popmotion";

import {
  SlideShowWrapper,
  SlideShowContainer,
  SlideShowImage,
  SlideNext,
  SlidePrev,
} from "./ModalSlideShowStyles";
//Framer-Motion Variants for slideshow
const variants = {
  enter(direction) {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: {
    zIndex: 0,
    x: 1000,
    opacity: 0,
  },
};

const swipeConfidenceThreshold = 10000;
const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};

const ModalSlideShow = ({ slides }) => {
  //Direction for slider
  const [[page, direction], setPage] = useState([0, 0]);
  //SLIDESHOW - Wrap from popmotion dependency
  const imageIndex = wrap(0, slides.slideShowPix.length, page);
  //New Direction & Page
  const paginate = (newDirection) => {
    setPage([page + newDirection, newDirection]);
  };
  return (
    <>
      <SlideShowWrapper>
        <SlideShowContainer>
          <AnimatePresence initial={false} custom={direction}>
            <SlideShowImage
              key={page} //required for AnimatePresence
              src={slides.slideShowPix[imageIndex]}
              //modalData = JSON Object file name
              //'slide' is a prop = index of items within the JSON Object
              // . = access your keyname
              //slideShowPix = keyname of your Key value pair inside the JSON Object
              //imageIndex = variable to hold array index of your slideShowPix
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{
                x: { type: "spring", stiffness: 300, damping: 30 },
                opacity: { duration: 0.2 },
              }}
              drag="x"
              dragConstraints={{ left: 0, right: 0 }}
              dragElastic={1}
              onDragEnd={(e, { offset, velocity }) => {
                const swipe = swipePower(offset.x, velocity.x);

                if (swipe < -swipeConfidenceThreshold) {
                  paginate(1);
                } else if (swipe > swipeConfidenceThreshold) {
                  paginate(-1);
                }
              }}
            />
          </AnimatePresence>

          <SlideNext
            whileHover={{ scale: 1.2, transition: { duration: 0.5 } }}
            whileTap={{ scale: 0.9 }}
            onClick={() => paginate(1)}
          >
            {">"}
          </SlideNext>
          <SlidePrev
            whileHover={{ scale: 1.2, transition: { duration: 0.5 } }}
            whileTap={{ scale: 0.9 }}
            onClick={() => paginate(-1)}
          >
            {"<"}
          </SlidePrev>
        </SlideShowContainer>
      </SlideShowWrapper>
    </>
  );
};

export default ModalSlideShow;
